<br />
<div class="container" *ngIf="cartProducts.length > 0">
  <div class="card">
    <div class="row">
      <div class="col-md-8 cart">
        <div class="title">
          <div class="row">
            <div class="col">
              <h4><b>Checkout</b></h4>
            </div>
            <div class="col align-self-center text-right text-muted"><a [routerLink]="['/products/cart-items']"><span
                  class="text-muted">Ritorna al Carrello</span></a>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col">
              <p class="text-muted text-center font-weight-light">Compila questo form con le tue informazioni e <span style="font-weight:bold; color: black;">inviaci il tuo ordine</span>. <br> Verrai contattato al più presto per accordarci sulle modalità di pagamento e spedizione.</p>
            </div>
          </div>
        </div>
        <form [formGroup]="profileForm">
          <div class="row">
            <div class="col-sm-6">
              <label for="first-name">Nome: </label>
              <input id="first-name" type="text" formControlName="firstName" class="form-control">

            </div>
            <div class="col-sm-6">
              <label for="last-name">Cognome: </label>
              <input id="last-name" type="text" formControlName="lastName" class="form-control">
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <label for="email">Email: </label>
              <input id="email" type="text" formControlName="email" class="form-control">
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <label for="telephone">Telefono: </label>
              <input id="telephone" type="text" formControlName="telephone" class="form-control" placeholder="Optional">
            </div>
          </div>
          <div class="row">
            <div class="col-sm-8">
              <label for="street">Via: </label>
              <input id="street" type="text" formControlName="street" class="form-control">
            </div>
            <div class="col-sm-4">
              <label for="house_number">Numero: </label>
              <input id="house_number" type="text" formControlName="house_number" class="form-control">
            </div>
          </div>
          <div class="row">
            <div class="col-sm-8">
              <label for="city">Città: </label>
              <input id="city" type="text" formControlName="city" class="form-control">
            </div>
            <div class="col-sm-4">
              <label for="zip_code">CAP: </label>
              <input id="zip_code" type="text" formControlName="zip_code" class="form-control">
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <label for="province">Provincia: </label>
              <input id="province" type="text" formControlName="province" class="form-control">
            </div>
            <div class="col-sm-12">
              <label for="state">Stato: </label>
              <input id="state" type="text" formControlName="state" class="form-control">
            </div>
          </div>
        </form>
      </div>
      <div class="col-md-4 summary">
        <div class="row">
          <div class="col-8" style="padding-left:0;">
            <h5><b>Il tuo Carrello</b></h5>
          </div>
        </div>
        <hr>
        <div class="row mb-2" *ngFor="let product of cartProducts">
          <div class="col-8" style="padding-left:0;">{{product.description | titlecase}}
            ({{productService.getProductQuantity(product.product_id)}})</div>
          <div class="col text-right">&euro; {{ productService.getProductQuantity(product.product_id)*product.price}}
          </div>
        </div>
        <div class="row" style="border-top: 1px solid rgba(0,0,0,.1); padding: 2vh 0;">
          <div class="col-8" style="padding-left:0;">OFFERTA MINIMA</div>
          <div class="col text-right">&euro; {{totalValue}}</div>
        </div>
        <button class="btn" type="submit" [disabled]="!profileForm.valid" (click)="onSubmit()">INVIA ORDINE</button>
      </div>
    </div>
  </div>
</div>